import React from 'react';
import './GlobalActionButton.css';
import { NavLink } from 'react-router-dom';
import { Button } from 'antd';
import useLocalizedPath from '../../i18n/useLocalizedPath';

const buttonConfig = {
  primary: {
    className: "btn-primary",
    color: "orange",
    variant: "solid",
    label: "Primary",
  },
  neutral: {
    className: "btn-neutral",
    color: "black",
    variant: "outlined",
    label: "Neutral",
  },
  secondary: {
    className: "btn-secondary",
    color: "orange",
    variant: "outlined",
    label: "Secondary",
  },
};

export default function GlobalActionButton({ type, to = "/contacts", label }) {
  const config = buttonConfig[type];
  const lp = useLocalizedPath();

  return (
    <div className="action-button">
      <NavLink to={lp(to)} className="nav-link">
        <Button
          color={config.color}
          variant={config.variant}
          className={config.className}
        >
          {label}
        </Button>
      </NavLink>
    </div>
  );
}
